/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */

import { Formik } from 'formik';
import { fetchSettings } from 'Helpers/utils';
import moment from 'moment';
import { arrayOf, func, number, shape, string } from 'prop-types';
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { getFile as getFileAction } from 'Redux/modules/files/actions';
import { countRecentMCs, getRecentMCs } from 'Redux/modules/patient/actions';
import * as Actions from 'Redux/modules/webChat/emc/actions';
import { Button, Modal, Segment } from 'semantic-ui-react';
import { getClinicDetail as actionGetClinicDetail } from 'Redux/modules/clinics/actions';
import { findClinicIdFromClinicsMapping } from 'Helpers/consult-utils';

import MedicalCertForm from '../MedicalCertForm/MedicalCertForm';
import MedicalCertificatePreview from '../MedicalCertificatePreview/MedicalCertificatePreview';

import styles from './MedicalCertModal.less';
import validation from './validation';

const getSignatureUrl = signatureFileId =>
  `${fetchSettings().FILE_API_URL}/files/${signatureFileId}`;

const displayFormat = 'YYYY-MM-DD';

const defaultFormValues = () => ({
  patientName: '',
  nricPassportNumber: '',
  medicalLeaveGrantedType: '',
  numberOfDays: 0,
  startDate: '',
  clinic: undefined,
  diagnosis: '',
});

class MedicalCertModal extends Component {
  constructor(props) {
    super(props);
    this.formRef = createRef();
    this.state = {
      loading: false,
      clinicName: '',
      clinicLogo: null,
      clinicChop: null,
    };
  }

  componentDidMount() {
    const {
      data: { cert, conversation },
      getListCertType,
      doctorId,
      getClinicsOfDoctor,
      getClinicDetail,
      profile,
      getConsultLatestCert,
    } = this.props;
    if (!cert) {
      this.fetchData();
    } else {
      getListCertType();
      getClinicsOfDoctor(doctorId);
    }

    getConsultLatestCert();

    const clinicId = findClinicIdFromClinicsMapping(
      conversation?.latestConsult?.clinics || [],
      profile?.id,
    );

    getClinicDetail(clinicId)
      .then(response => {
        this.setState({
          clinicName: response.data?.name,
          clinicLogo: response.data?.logo,
          clinicChop: response.data?.chop,
        });
      })
      .catch(error => {
        console.error(error);
      });
  }

  componentWillUnmount() {
    const { resetCert } = this.props;
    resetCert();
  }

  fetchData = async () => {
    const {
      getListCertType,
      getFile,
      profile: { id, signatureFileId },
      data: { conversation },
    } = this.props;

    const certTypesResponse = await getListCertType();
    const defaultCertType = (certTypesResponse.data || []).find(certType => certType.isDefault);

    // set default form values after call APIs
    this.formRef.current?.setFieldValue(
      'patientName',
      conversation?.latestConsult?.forPatient?.fullName,
    );
    this.formRef.current?.setFieldValue(
      'nricPassportNumber',
      conversation?.latestConsult?.forPatient?.nric,
    );
    this.formRef.current?.setFieldValue('medicalLeaveGrantedType', defaultCertType?.id || '');
    this.formRef.current?.setFieldValue('numberOfDays', 1);
    this.formRef.current?.setFieldValue('startDate', moment());
    this.formRef.current?.setFieldValue(
      'clinic',
      findClinicIdFromClinicsMapping(conversation?.latestConsult?.clinics || [], id),
    );
    this.formRef.current?.setFieldValue('diagnosis', '');

    await getFile(signatureFileId);
  };

  onClickKeyword = keyword => {
    this.formRef.current.setFieldValue(
      'diagnosis',
      `${this.formRef.current?.values?.diagnosis}${keyword.value} `,
    );
  };

  handleClickSubmit = async () => {
    try {
      const {
        profile: { signatureFileId } = {},
        data: {
          conversation: {
            latestConsult: {
              id: consultId,
              patient: { id: patientId },
              forPatient: { id: forPatientId },
            },
            id: threadId,
          },
          onClose,
        },
        files: { details: fileInfo },
        createCert,
        getMCs,
      } = this.props;

      this.setState({
        loading: true,
      });

      const {
        clinic: clinicId,
        patientName,
        startDate,
        numberOfDays: days,
        medicalLeaveGrantedType: certTypeId,
        nricPassportNumber: patientNric,
        diagnosis,
      } = this.formRef.current.values || {
        clinic: undefined,
        qualification: '',
        patientName: '',
        startDate: null,
        numberOfDays: 0,
        medicalLeaveGrantedType: '',
        nricPassportNumber: '',
        signaturePad: '',
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        diagnosis,
      };

      // format start_date to fulfill validation
      const startDateValue = startDate && typeof startDate === 'object' ? startDate._d : startDate;
      const startDateFormatted = moment(startDateValue).format(displayFormat);

      const data = {
        threadId,
        patientName,
        patientNric,
        days,
        startDate: startDateFormatted,
        certTypeId,
        signFileId: signatureFileId,
        clinicId,
        patientId,
        forPatientId,
        consultId,
        serviceType: 'consult',
        diagnosis,
      };

      if (fileInfo) {
        data.qualification = fileInfo.comment;
      }

      await createCert(data);

      // reload MC List
      const consultServiceId = this.props.conversation?.latestConsult?.service?.id;
      getMCs(forPatientId, clinicId, consultServiceId);

      onClose();
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  render() {
    const { loading, clinicName, clinicLogo, clinicChop } = this.state;

    const {
      initialValues,
      emc: {
        clinic: {
          status: { loading: statusClinic },
        },
        certType: {
          certTypes,
          status: { loading: statusCertType },
        },
        certification: { error: createCertError },
      },
      profile: { signatureFileId } = {},
      files: { details: fileInfo },
      data: {
        onClose,
        cert,
        conversation: {
          latestConsult: {
            patient: { id: patientId, phoneCountryCode, nric, fullName },
            forPatient: { id: forPatientId, dateOfBirth },
          },
        },
      },
    } = this.props;

    const loadingDetails = statusClinic === 0 || statusCertType === 0;

    const signatureUrl = getSignatureUrl(signatureFileId);

    const isBookForSelf = patientId === forPatientId;
    const isSingaporeCitizen = phoneCountryCode === '+65';
    const isNeedValidationAge = isBookForSelf && isSingaporeCitizen;

    const reInitialValues = cert
      ? {
          ...initialValues,
          patientName: cert.patientName ?? '',
          nricPassportNumber: cert.patientNric ?? '',
          medicalLeaveGrantedType: cert.certTypeId ?? '',
          numberOfDays: cert.days ?? 0,
          startDate: cert.startDate ? moment(cert.startDate) : '',
          clinic: cert.clinicId ?? undefined,
          diagnosis: cert.diagnosis ?? '',
        }
      : initialValues;

    return (
      <div>
        <Formik
          onSubmit={this.handleClickSubmit}
          validationSchema={validation(isNeedValidationAge)}
          initialValues={reInitialValues}
          innerRef={this.formRef}>
          {({ handleSubmit, values }) => (
            <Modal open size="large" style={{ position: 'relative' }} closeOnDimmerClick>
              <Modal.Content>
                <Segment style={{ border: 'none' }} loading={loadingDetails}>
                  <div className={styles.innerContent}>
                    <div className={styles.leftColumn}>
                      <h3>CREATE MEDICAL CERTIFICATE</h3>
                      <MedicalCertForm
                        certTypes={certTypes}
                        onClickKeyword={this.onClickKeyword}
                        clinicName={clinicName}
                      />
                    </div>
                    <div className={styles.previewColumn}>
                      <h3 className={styles.previewText}>PREVIEW</h3>
                      <div className={styles.rightColumn}>
                        <MedicalCertificatePreview
                          signatureUrl={signatureUrl}
                          description={fileInfo?.comment}
                          formData={values}
                          isBookForSelf={isBookForSelf}
                          nric={nric}
                          name={fullName}
                          dateOfBirth={dateOfBirth}
                          clinicLogo={clinicLogo}
                          clinicChop={clinicChop}
                        />
                      </div>
                    </div>
                  </div>
                </Segment>
              </Modal.Content>
              <Modal.Actions>
                <div className={styles.modalActions}>
                  {createCertError ? (
                    <span className={styles.errorText}>{createCertError}</span>
                  ) : (
                    <div />
                  )}

                  <div>
                    <Button onClick={onClose} content="Cancel" type="button" />
                    <Button
                      disabled={loadingDetails || loading}
                      loading={loading}
                      primary
                      content="Submit"
                      type="submit"
                      onClick={handleSubmit}
                    />
                  </div>
                </div>
              </Modal.Actions>
            </Modal>
          )}
        </Formik>
      </div>
    );
  }
}

MedicalCertModal.propTypes = {
  createCert: func.isRequired,
  resetCert: func.isRequired,
  initialValues: shape({}).isRequired,
  getClinicsOfDoctor: func.isRequired,
  getListCertType: func.isRequired,
  getFile: func.isRequired,
  getMCs: func.isRequired,
  files: shape({}).isRequired,
  profile: shape({}).isRequired,
  doctorId: number.isRequired,
  conversation: shape({
    id: number,
    patient: shape({ id: number }),
  }).isRequired,
  emc: shape({
    clinic: shape({
      clinics: arrayOf(shape({})),
      status: shape({ loading: number }),
    }),
    certType: shape({
      certTypes: arrayOf(shape({})),
      status: shape({ loading: number }),
    }),
    certification: shape({
      error: string,
    }),
  }).isRequired,
};

MedicalCertModal.defaultProps = {};

const mapStateToProps = state => ({
  doctorId: state.auth.data.accountId,
  emc: state.webChat.emc,
  files: state.files,
  initialValues: defaultFormValues,
  profile: state.doctors.profile,
});

const mapDispatchToProps = dispatch => ({
  createCert: data => dispatch(Actions.createCert(data)),
  resetCert: () => dispatch(Actions.resetCert()),
  getListCertType: () => dispatch(Actions.getListCertType()),
  getClinicsOfDoctor: doctorId => dispatch(Actions.getClinicsOfDoctor(doctorId)),
  getFile: id => dispatch(getFileAction(id)),
  getMCs: (forPatientId, clinicId, consultServiceId) => {
    dispatch(getRecentMCs(forPatientId, { clinicId }));
    dispatch(countRecentMCs(forPatientId, clinicId, consultServiceId));
  },
  getClinicDetail: clinicId => dispatch(actionGetClinicDetail(clinicId)),
  getConsultLatestCert: () => dispatch(Actions.getConsultLatestCert()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MedicalCertModal);
